<template>

	<div>

        <div class="form-group form-active  pt20">
            <label for="nome">Seu nome completo</label>
            <input type="text" class="form-control" :class="{ 'is-invalid': nomeInvalido }"
                id="nome" name="nome"
                v-model="dadosCadastrais.nome" />

            <div v-if="nomeInvalido" class="invalid-feedback">
                <p>O campo nome é obrigatório!</p>
            </div>

        </div>

        <div class="form-group  pt20">
            <label for="nome_empresa">Nome da sua empresa</label>
            <input type="text" class="form-control" :class="{ 'is-invalid': nomeEmpresaInvalido }"
                id="nome_empresa" name="nome_empresa"
                v-model="dadosCadastrais.nomeEmpresa" />

            <div v-if="nomeEmpresaInvalido" class="invalid-feedback">
            	<p>O campo nome da sua empresa é obrigatório!</p>
            </div>
        </div>

        <div class="form-group pt20">
			<label for="area_atuacao">Área de atuação</label>
			<select class="form-control" id="area_atuacao" name="area_atuacao" v-model="dadosCadastrais.areaAtuacao" :class="{ 'is-invalid': areaAtuacaoInvalido }">
				<option v-for="area in areaAtuacao" :value="area.id">{{area.nome}}</option>
			</select>

			<div v-if="areaAtuacaoInvalido" class="invalid-feedback">
				<p>Selecione uma opção!</p>
            </div>
		</div>

        <div class="form-group  pt20">
            <label for="email">Seu e-mail para contato</label>
            <input type="email" class="form-control" :class="{ 'is-invalid': emailInvalido }"
                id="email" name="email"
                v-model="dadosCadastrais.email" />

            <div v-if="emailInvalido" class="invalid-feedback">
            	<p>Entre com um email válido!</p>
            </div>
        </div>

		<div class="text-right">
			<button class="btn btn-primary" @click="proximo">Próximo</button>
		</div>

	</div>

</template>

<script>

export default {
	name: "DadosCadastrais",
	props: ['areaAtuacao'],
	data() {
        return {
        	dadosCadastrais: {
	            nome: null,
	            nomeEmpresa: null,
	            areaAtuacao: null,
	            email: null,
        	},
        	nomeInvalido: false,
        	nomeEmpresaInvalido: false,
        	areaAtuacaoInvalido: false,
        	emailInvalido: false,
        }
    },
	methods: {
		proximo () {

			if (!this.dadosCadastrais.nome) {
				this.nomeInvalido = true;
			}
			else {
				this.nomeInvalido = false;
			}

			if (!this.dadosCadastrais.nomeEmpresa) {
				this.nomeEmpresaInvalido = true;
			}
			else {
				this.nomeEmpresaInvalido = false;
			}

			if (!this.dadosCadastrais.areaAtuacao) {
				this.areaAtuacaoInvalido = true;
			}
			else {
				this.areaAtuacaoInvalido = false;
			}

			if (!this.dadosCadastrais.email) {
				this.emailInvalido = true;
			} else if (!this.validEmail(this.dadosCadastrais.email)) {
				this.emailInvalido = true;
			}
			else {
				this.emailInvalido = false;
			}

			if (!this.nomeInvalido && !this.nomeEmpresaInvalido && !this.areaAtuacaoInvalido && !this.emailInvalido) {
				this.$parent.showQuestionarios(this.dadosCadastrais);
			}

		},
		validEmail (email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
    	},
	}
}
</script>

<style scoped>

</style>
